import React from "react"
import BaseButton from "@components/UI/Button"
import { twMerge } from "tailwind-merge";
import { Plan } from "./plansData";
import { PaymentPlan } from "./paymentPlansData";

// local cast to avoid untyped component typing errors
const Button = BaseButton as React.ComponentType<any>

export type StartButtonProps = {
  className?: string
  paymentPlan: PaymentPlan
  plan: Plan
  trialButtonChildren?: React.ReactNode
  salesButtonChildren?: React.ReactNode
}

const startButtonClassName = "w-full !text-sm !py-[11px] !px-[20px] !font-normal"

export function StartButton({ className, paymentPlan, plan, trialButtonChildren, salesButtonChildren }: StartButtonProps) {
  if (!paymentPlan) {
    return
  }

  switch (plan.buttonType) {
    case "free": return (
      <StartFreeButton
        className={className}
        paymentPlan={paymentPlan}
        plan={plan}
      />
    )
    case "trial": return (
      <StartTrialButton
        className={className}
        paymentPlan={paymentPlan}
        plan={plan}
        trialButtonChildren={trialButtonChildren}
      />
    )
    case "sales": return <ContactSalesButton className={className} salesButtonChildren={salesButtonChildren} />
  }
}

export function StartFreeButton({ className, plan, paymentPlan }: StartButtonProps) {
  return (
    <Button
      className={twMerge(startButtonClassName, className)}
      size={20}
      tag='a'
      type='link'
      href={`${process.env.NEXT_PUBLIC_APP_TRAQQ_URL}/signup?team_size=${plan.defaultTeamSize}&period=${paymentPlan.name.toLowerCase()}&utm_campaign=button&utm_term=${'Start%2Bfor%2BFree'}&utm_source=site&utm_medium=page`}
      variant={plan.recommended ? 'primary' : 'secondary'}
      mods={{ signup: true }}
    >
      Start for free
    </Button>
  )
}

function StartTrialButton({ className, paymentPlan, plan, trialButtonChildren = "14-day free trial" }: StartButtonProps) {
  return (
    <Button
      className={twMerge(startButtonClassName, className)}
      size={20}
      tag='a'
      type='link'
      href={`${process.env.NEXT_PUBLIC_APP_TRAQQ_URL}/signup?team_size=${plan.defaultTeamSize}&period=${paymentPlan.name.toLowerCase()}&utm_campaign=button&utm_term=${'Start%2BFree%2BTrial'}&utm_source=site&utm_medium=page`}
      variant={plan.recommended ? 'primary' : 'secondary'}
      mods={{ signup: true }}
    >
      {trialButtonChildren}
    </Button>
  )
}

function ContactSalesButton({ className, salesButtonChildren = "Contact our team" }: Pick<StartButtonProps, "className" | "salesButtonChildren"> = {}) {
  return (
    <Button
      className={twMerge(startButtonClassName, className)}
      tag='a'
      type='link'
      href='/contact?utm_campaign=button&utm_term=Contact+Us&utm_source=site&utm_medium=page'
      variant='secondary'
    >
      {salesButtonChildren}
    </Button>
  )
}
